import React from "react";
import { useIntl } from "react-intl";
import { ChevronLeft } from "@piiqtechnologies/svg-icons";
import { PeekDivider, PeekSkeleton, PeekStack } from "@piiqtechnologies/ui-components";
import { AnalyticsArea, useActiveCommunity, useCommunityReportSelection, useSubtopicsBanner, useTrackEvent, } from "@hooks";
import { AppShellHeader } from "@layouts";
import { PageHeader } from "../page-header";
import { ReportDateSelector } from "../report-date-selector";
import { SubtopicsStatusBanner } from "../subtopics-status-banner";
import { HEADER_BUTTON_SIZE, HeaderDownloadButton, HeaderSettingsButton } from "./components";
/**
 * The one top header the shell's pages share: same controls in the same place, only the title
 * and the back link change. Rendered into the shell's fixed header slot, so it never scrolls.
 */
export const PageTopHeader = ({ communityId, communityName, title, backLabel, onBack, sectionNav, download, banner, showDivider = false, reportSelectorReadOnly = false, titleAdornment, initials, }) => {
    var _a;
    const intl = useIntl();
    const track = useTrackEvent();
    useActiveCommunity(communityId);
    const { reports, loading: reportsLoading, selectedReportId, selectReport } = useCommunityReportSelection(communityId);
    const selectedReport = reports.find((report) => report.reportId === selectedReportId);
    const subtopicsBanner = useSubtopicsBanner({ communityId, reports, selectedReportId });
    // Report Settings resolves either id: it looks the param up as a reportId first and falls
    // back to a templateId. Preferring the template lands straight on the configuration; the
    // report id keeps the button working for a report whose template is gone.
    const settingsId = (_a = selectedReport === null || selectedReport === void 0 ? void 0 : selectedReport.templateId) !== null && _a !== void 0 ? _a : selectedReportId;
    const handleSelectReport = (reportId) => {
        var _a;
        track(AnalyticsArea.Navigation, "Report Date Selected", {
            subjectId: communityId,
            reportId,
            isActive: (_a = reports.find((report) => report.reportId === reportId)) === null || _a === void 0 ? void 0 : _a.isActive,
        });
        selectReport(reportId);
    };
    return (React.createElement(AppShellHeader, null,
        React.createElement(PeekStack, { gap: 1.5, sx: { pb: 1.5 } },
            banner,
            React.createElement(PageHeader, { topTitle: onBack
                    ? { icon: React.createElement(ChevronLeft, null), label: backLabel !== null && backLabel !== void 0 ? backLabel : "", labelSkeleton: !backLabel, onClick: onBack }
                    : undefined, title: title || React.createElement(PeekSkeleton, { variant: "text", width: 320 }), titleAdornment: titleAdornment, initials: initials, actions: React.createElement(React.Fragment, null,
                    reportsLoading ? (React.createElement(PeekSkeleton, { variant: "rounded", width: 200, height: HEADER_BUTTON_SIZE })) : (React.createElement(ReportDateSelector, { reports: reports, selectedReportId: selectedReportId, onSelect: handleSelectReport, readOnly: reportSelectorReadOnly })),
                    React.createElement(HeaderSettingsButton, { communityId: communityId, communityName: communityName, settingsId: settingsId }),
                    download && React.createElement(HeaderDownloadButton, Object.assign({}, download))) }),
            sectionNav,
            React.createElement(SubtopicsStatusBanner, { state: subtopicsBanner }),
            showDivider && React.createElement(PeekDivider, { light: true }))));
};
export default PageTopHeader;
